import { RootState } from "redux-store";

export const getEventsList = (state: RootState) => state?.event?.list ?? [];
export const isCreateEventDialogOpen = (state: RootState) =>
  state?.event?.isCreateEventDialogOpen ?? false;
export const EditEventDialogState = (state: RootState) =>
  state?.event?.editEventDialogState ?? {
    isOpen: false,
    editMode: false,
    editImage: false,
    selectedEvent: null,
  };
export const getSingleUseEvent = (state: RootState) =>
  state?.event?.singleUseEvent ?? null;
